import React, { PureComponent } from 'react';
import { Navigate, NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
/*import { FormattedMessage } from 'react-intl';*/
import { Approvals } from 'cloak-file-sdk-web'
import ClearIcon from '@mui/icons-material/Clear';
import { CloakUtilService } from 'cloak-file-sdk-web'

class ApprovalsPage extends PureComponent {

    constructor(props){
        super(props)
        this.state = {
        }
    }

    componentDidMount() {
      console.log("In ApprovalsPage componentDidMount")
      CloakUtilService().checkInactivityLogout(this.props)
    }

    render() {
        const { token } = this.props;

        const back = (
                <NavLink to="/cloak/cloak" style={{marginTop: 5, color: 'rgba(0, 0, 0, 0.54)'}}>
                    <ClearIcon/>
                </NavLink>
            )

        if ( !token ) {
            return <Navigate to="/cloak/login"/>;
        }

        return (
                <div>
                    <div className='clk-sol-approval-table-div'>
                        <Approvals backLink={back} />
                    </div>
                </div>
        );
    }
}



const mapStateToProps = state => {
    return {
    token: state.auth.token
  }
};

export default connect(mapStateToProps)(ApprovalsPage);
